// extracted by mini-css-extract-plugin
module.exports = {"officeInformation":"OfficeInformation_officeInformation__JEH52"};